var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDashboard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11111 11.1111H7.77778C8.38889 11.1111 8.88889 10.6111 8.88889 10V1.11111C8.88889 0.5 8.38889 0 7.77778 0H1.11111C0.5 0 0 0.5 0 1.11111V10C0 10.6111 0.5 11.1111 1.11111 11.1111ZM1.11111 20H7.77778C8.38889 20 8.88889 19.5 8.88889 18.8889V14.4444C8.88889 13.8333 8.38889 13.3333 7.77778 13.3333H1.11111C0.5 13.3333 0 13.8333 0 14.4444V18.8889C0 19.5 0.5 20 1.11111 20ZM12.2222 20H18.8889C19.5 20 20 19.5 20 18.8889V10C20 9.38889 19.5 8.88889 18.8889 8.88889H12.2222C11.6111 8.88889 11.1111 9.38889 11.1111 10V18.8889C11.1111 19.5 11.6111 20 12.2222 20ZM11.1111 1.11111V5.55556C11.1111 6.16667 11.6111 6.66667 12.2222 6.66667H18.8889C19.5 6.66667 20 6.16667 20 5.55556V1.11111C20 0.5 19.5 0 18.8889 0H12.2222C11.6111 0 11.1111 0.5 11.1111 1.11111Z",
    fill: "#6D675F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.c0f47431.svg";
export { ForwardRef as ReactComponent };